export default "__VITE_ASSET__1bf15277__"